import { CheckSquareIcon, XSquareIcon, PercentIcon } from "@phosphor-icons/react"
import moment from "moment"
import TableHeader from "../../components/generic/TableHeader"
import { useState } from "react"
import TimeAnalysisSkeleton from "./TimeAnalysisHourSkeleton"
import NoData from "../generic/NoData"
import { useNavigate } from "react-router-dom"

const TimeAnalysisHourBreakdown = ({ data, loading, onResetFilters }) => {
  const [showPercentage, setShowPercentage] = useState(true)
  const navigate = useNavigate()

  if (loading) return <TimeAnalysisSkeleton />
  if (!data || data.length === 0) return <NoData onResetAll={onResetFilters} />

  console.log("d", data)

  return (
    <div className="border-r border-l rounded-b-lg border-[var(--q3-stroke-light)]">
      {/* Table Heading */}
      <TableHeader
        headerTitle="Hour-wise Breakdown"
        showBottomBorder={false}
        headerSwitch={
          <span className="flex items-center gap-1">
            <PercentIcon size={16} weight="bold" />
            Show Percentage
          </span>
        }
        headerSwitchCase={showPercentage}
        headerSwitchHandler={setShowPercentage}
      />

      {/* Legend row */}
      <div className="mt-2 sm:mt-3 flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-6 text-sm px-4">
        <div className="flex items-center gap-2">
          <CheckSquareIcon size={20} color="var(--q3-green-normal)" />
          <span className="text-[var(--q3-green-normal)]">Correct Attempts</span>
        </div>
        <div className="flex items-center gap-2">
          <XSquareIcon size={20} color="var(--q3-danger-normal)" />
          <span className="text-[var(--q3-danger-normal)]">Incorrect Attempts</span>
        </div>
      </div>

      {/* Scroll wrapper */}
      <div className="overflow-x-auto mt-4">
        <div className="min-w-[700px] border border-[var(--q3-stroke-light)] rounded-b-lg overflow-hidden">
          {/* Table Head */}
          <div className="bg-[var(--q3-surface-dim)] text-sm font-medium text-[var(--q3-neutral-default)]">
            <div className="grid grid-cols-4 divide-x divide-[var(--q3-stroke-light)]">
              <div className="p-4">Test Title</div>
              <div className="p-4 text-center">1st Hour</div>
              <div className="p-4 text-center">2nd Hour</div>
              <div className="p-4 text-center">3rd Hour</div>
            </div>
          </div>

          {/* Table Body */}
          {data.map((test, index) => (
            <div
              key={index}
              className="grid grid-cols-4 divide-x divide-[var(--q3-stroke-light)] border-t border-[var(--q3-stroke-light)] text-sm text-[var(--q3-neutral-default)]"
            >
              {/* Test Info (Clickable) */}
              <div
                className="p-4 cursor-pointer hover:bg-[var(--q3-surface-hover)]"
                onClick={() =>
                  navigate(`/${test.packId}/${test.testId}/analysis`)
                }
              >
                <div className="font-medium truncate overflow-hidden whitespace-nowrap">
                  {test.detailedAnalysis?.title}
                </div>
                <div className="text-sm text-[var(--q3-neutral-light)]">
                  {moment(test.detailedAnalysis?.submittedAt).format("D MMM YYYY")}
                  {test.detailedAnalysis?.isBonusAvailable &&
                    test.detailedAnalysis?.isBonusAttempted &&
                    " | Bonus Qs Attempted"}
                </div>
              </div>

              {/* Hour-wise Stats */}
              {[0, 1, 2].map(hourIndex => {
                const hour = test.detailedAnalysis?.timeTravelHourly?.[hourIndex] || {}
                const correct = hour.correct || 0
                const incorrect = hour.incorrect || 0
                const total = correct + incorrect

                const formatValue = val =>
                  showPercentage && total > 0 ? `${Math.round((val / total) * 100)}%` : val

                return (
                  <div
                    key={hourIndex}
                    className="p-4 flex items-center justify-center gap-3 text-center"
                  >
                    <div className="flex items-center gap-1">
                      <CheckSquareIcon size={16} color="var(--q3-green-normal)" />
                      <span className="font-medium">{formatValue(correct)}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <XSquareIcon size={16} color="var(--q3-danger-normal)" />
                      <span className="font-medium">{formatValue(incorrect)}</span>
                    </div>
                  </div>
                )
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default TimeAnalysisHourBreakdown
